var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconButtonLinkedIn = function SvgIconButtonLinkedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.917,
    y1: 0.269,
    x2: 5.697,
    y2: 1.347,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0089c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076b6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.224,
    y1: 0.356,
    x2: 5.816,
    y2: 3.277,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.657,
    y1: -0.003,
    x2: 1.471,
    y2: 1.043,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-button-linked-in",
    transform: "translate(.5 .5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle_button",
    "data-name": "circle button"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle_button-2",
    "data-name": "circle button",
    cx: 18,
    cy: 18,
    r: 18,
    fill: "rgba(255,255,255,0)",
    stroke: "#f2f2f2",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon-linked-in",
    transform: "translate(11.437 9.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    transform: "translate(.317 5.333)",
    fill: "url(#linear-gradient)",
    d: "M0 0h3.303v10.672H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M775.012 60.586a1.969 1.969 0 1 1 1.954-1.969 1.961 1.961 0 0 1-1.954 1.969Z",
    transform: "translate(-773.059 -56.647)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M789.776 73.282h-3.287v-5.6c0-1.536-.584-2.394-1.8-2.394-1.322 0-2.012.893-2.012 2.394v5.6h-3.169V62.609h3.169v1.437a3.722 3.722 0 0 1 3.216-1.763c2.262 0 3.883 1.382 3.883 4.24v6.758Z",
    transform: "translate(-773.776 -57.276)",
    fill: "url(#linear-gradient-3)"
  })))));
};
export { SvgIconButtonLinkedIn as ReactComponent };
export default "data:image/svg+xml;base64,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";